// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var ResizeHorizontal = function ResizeHorizontal(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M6.3 2.7l-5 5a.4.4 0 000 .6l4.9 4.9a.4.4 0 00.7-.3V3a.4.4 0 00-.6-.3zM9.7 13.2l4.9-4.9a.4.4 0 000-.6l-4.9-5A.4.4 0 009 3v9.9a.4.4 0 00.7.3z"
    }))
  );
};

export default ResizeHorizontal;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/ResizeHorizontal.js
// module id = 1044
// module chunks = 0